import * as React from 'react'
import { useCallback } from 'react'

import Paper from '@mui/material/Paper'

import { BillToSearchSelectContents } from './BillToSearchSelectContents'
import { BillTo } from '@user/store/entityLocations'

type Props = {
  location: BillTo
  onClick: (locationId: string) => void
  searchText?: string
}

export function BillToSearchCard(props: Props) {
  const { location, onClick, searchText } = props

  const handleClick = useCallback(() => {
    onClick(location.id)
  }, [location.id, onClick])

  return (
    <Paper
      elevation={1}
      variant="elevation"
      sx={{
        mb: 1,
        pt: '12px',
        px: '16px',
        pb: '12px',
      }}
    >
      <BillToSearchSelectContents
        location={location}
        searchText={searchText}
        onSelectBillTo={handleClick}
      />
    </Paper>
  )
}
